import { GetSellerPayLinkResponse } from '@iwoca/lapi-client/edge';
import { Card, Pill } from '@iwoca/orion';

import styles from './PaymentActivity.module.css';
import { LinkWithQuery } from '../../../../components/LinkWithQuery/LinkWithQuery';
import chevronRight from '../../../../components/svg/ChevronRight.svg';
import { clipText } from '../../../../utils/ClipText';
import { displayCurrency } from '../../../../utils/DisplayCurrency';
import { getFormattedDate } from '../../../../utils/DisplayDate';
import { PayLinkStatus } from '../../../Payments/components/PayLinkStatus/PayLinkStatus';
import { getPayLinkTypeNameFromSource } from '../../../Payments/components/PayLinkTable/PayLinkTable';
import { usePayLinks } from '../../../Payments/hooks/usePaylinks.hook';
import { PayLinkSource } from '../../../Payments/util/payments.types';

const sanitiseText = clipText(50);

export const PaymentActivity = () => {
  const { payLinks } = usePayLinks({ orderBy: 'last_updated' });

  // Endpoint doesn't support custom page sizes, for now we can just do this on FE
  const PAGE_SIZE = 5;

  const mapProductDurationToDescription = (
    product_duration: GetSellerPayLinkResponse['data'][number]['product_duration'],
  ) => {
    if (product_duration === 'TWELVE_MONTHS') {
      return 'Pay in 12';
    }
    return 'Pay in 3';
  };

  return (
    <Card className={styles.wrap}>
      <div className={styles.header}>
        <div className={styles.heading}>Recent payment statuses</div>
        <LinkWithQuery
          className={styles.seeAllPaymentsLink}
          to="/pay/payments/"
        >
          See all payments
          <img src={chevronRight} alt="arrow" className={styles.chevron} />
        </LinkWithQuery>
      </div>
      <div>
        {payLinks.slice(0, PAGE_SIZE).map((paylink) => (
          <div key={`payment__${paylink.id}`} className={styles.paymentCard}>
            <div className={styles.paymentDetails}>
              <div>
                <div className={styles.reference}>{paylink.reference}</div>
                <div className={styles.businessName}>
                  {sanitiseText(paylink.buyer_name || '-').toLowerCase()}
                </div>
              </div>
              <div className={styles.rightHandInfo}>
                <div className={styles.amount}>
                  {displayCurrency(paylink.amount)}
                </div>
              </div>
            </div>
            <div className={styles.paymentInfo}>
              <PayLinkStatus paylink={paylink} />
              <div>
                <div className={styles.rightHandInfo}>
                  <div className={styles.statusPillLabel}>
                    <Pill>
                      {getPayLinkTypeNameFromSource(
                        paylink.source as PayLinkSource,
                      )}
                    </Pill>
                  </div>
                  <div className={styles.createdText}>
                    {getFormattedDate(paylink.created!).toUpperCase()}
                  </div>
                </div>
              </div>
            </div>
            {paylink.product_duration ? (
              <div className={styles.product_duration}>
                {mapProductDurationToDescription(paylink.product_duration)}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </Card>
  );
};
